import { db } from "../firebase";

const formatHours = (time) => {
  const hours = time.split(":");
  if (parseInt(hours[0], 10) < 10) {
    return `0${hours[0]}:${hours[1]} H`;
  }
  return `${hours[0]}:${hours[1]} H`;
};

const formatDate = (rawDate) => {
  const date = rawDate.split("/");
  if (parseInt(date[1], 10) < 10) {
    return `${date[0]}/0${date[1]}/${date[2]}`;
  }
  return `${date[0]}/${date[1]}/${date[2]}`;
};

export const getRates = async () => {
  const data = [];

  const docs = await db.collection("rates").orderBy("date", "desc").get();
  docs.forEach((doc) => {
    data.push(doc.data());
  });

  const rawDate = new Date(data[0].dateUTC).toLocaleDateString("es-ES", {
    timeZone: "Europe/Madrid",
  });

  const rawHours = new Date(data[0].dateUTC).toLocaleTimeString("es-ES", {
    timeZone: "Europe/Madrid",
  });

  const lastRate = {
    amount: data[0].amount,
    date: formatDate(rawDate),
    hours: formatHours(rawHours),
  };

  return lastRate;
};
